import type { FC } from "react";

import { Modal } from "@similarweb/ui-components";

import type { SegmentsModalProps } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/types";

import { STEPS_COMPONENTS } from "./StepComponents";

interface ISegmentName {
    assetName: string;
    isValidName: boolean;
    errorMessage?: string;
}

interface ISegmentCreationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    saveProps: {
        onSave: () => void;
        isDisabled: boolean;
        isLoading: boolean;
    };
    segmentName: ISegmentName;
    onSegmentNameChange: (assetName: string) => void;
    isCreatingSegment: boolean;
    popupStep: string;
    goBack: () => void;
    analyzeSegment: () => void;
}

const SegmentModal: FC<SegmentsModalProps> = (props) => {
    const { step } = props;
    const Component = STEPS_COMPONENTS[step];
    return <Component {...props} />;
};

export const SegmentCreationModal: FC<ISegmentCreationModalProps> = ({
    isOpen,
    onCancel,
    saveProps,
    segmentName,
    onSegmentNameChange,
    isCreatingSegment,
    popupStep,
    goBack,
    analyzeSegment,
}) => {
    if (!isOpen) {
        return null;
    }
    const MODAL_STYLES: ReactModal.Styles = {
        content: {
            boxSizing: "border-box",
            width: "550px",
            padding: 0,
        },
    };
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            customStyles={MODAL_STYLES}
        >
            <SegmentModal
                footerProps={{ onCancel, saveProps }}
                bodyProps={{
                    onSegmentNameChange,
                    segmentName,
                    isLoading: isCreatingSegment,
                }}
                step={popupStep}
                checkoutFooterProps={{
                    goBack,
                    analyzeSegment,
                }}
            />
        </Modal>
    );
};
